export const trainQueryKeys = {
    quote: (params) => ['train', 'quote', params],
    networks: () => ['train', 'networks'],
    prices: () => ['train', 'prices'],
    swapHistory: (addresses, page) => ['train', 'swapHistory', { addresses, page }],
    order: (hashlock, solverAddress) => ['train', 'order', { hashlock, solverAddress }],
    userLock: (hashlock) => ['train', 'userLock', hashlock],
    solverLock: (hashlock) => ['train', 'solverLock', hashlock],
};
